import { GridSizeType, gridSize } from '@/shared';
import { Chip, Grid, SxProps, Theme } from '@mui/material';

export type ChipModelStateProps = {
  label: string;
  color?: 'primary' | 'secondary' | 'warning' | 'error' | 'info' | 'success';
  variant?: 'filled' | 'outlined';

  size?: GridSizeType;
  justifyContent?:
  | 'flex-start'
  | 'center'
  | 'flex-end'
  | 'space-between'
  | 'space-around'
  | 'space-evenly';
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';

  sxChip?: SxProps<Theme>;
};

const ChipModelState: React.FC<ChipModelStateProps> = ({
  label,
  color = 'success',
  variant = 'outlined',

  size = gridSize,
  justifyContent = 'center',
  alignItems = 'center',
  sxChip = {
    width: '100%',
    textAlign: 'center',
    fontWeight: 500,
    fontSize: '14px',
  },
}) => {
  return (
    <Grid
      item
      {...size}
      container
      justifyContent={justifyContent}
      alignItems={alignItems}
    >
      <Chip label={label} color={color} variant={variant} sx={sxChip} />
    </Grid>
  );
};

export default ChipModelState;
